export class AppGlobals {

    static correlatorId: string;
}
